import { useSetting } from '../../../util/useSetting';
import { useState } from 'react';
import PreviousSvg from '../../../svg/student/Previous.js';
import NextSvg from '../../../svg/student/Next.js';
import ReloadSvg from '../../../svg/student/Reload.js';

export default function RenderASection({ section }) {
    const { fontSize } = useSetting();
    return (
        <div className='flex flex-col items-center justify-start gap-[16px] w-full rounded-[8px] py-[16px]' style={section.backgroundImage ? { backgroundImage: `url(${section.backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundColor: section.backgroundColor || 'transparent' } : { backgroundColor: section.backgroundColor || 'transparent' }}>
            {section?.contents?.map((content, contentIndex) => (
                <div key={contentIndex} className='text-black w-full flex items-center justify-center'>
                    {content.type === '圖片' ?
                        <img className='px-[32px]' src={content.url} alt='' />
                        : content.type === '標題' ?
                            <div className='text-black font-bold text-center w-[90%] px-[32px]' style={{ fontSize: fontSize + 4 }}>{content.text}</div>
                            : content.type === '文字' ?
                                <div className='px-[32px] py-[8px] text-justify flex flex-col items-center justify-center font-[400]' dangerouslySetInnerHTML={{ __html: content.text }}></div>
                                : content.type === 'tabs' ?
                                    <RenderTabs content={content} />
                                    : content.type
                    }
                </div>
            ))}
        </div>
    )
}

function RenderTabs({ content }) {
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const { fontSize } = useSetting();
    return (
        <div className='flex flex-col py-[16px]'>
            <div className='w-full flex flex-row justify-start gap-[8px] px-[16px] font-[900] bg-[#EEF2F6] pt-[8px]'>
                {content.tabs?.map((tab, ti) => (

                    <button
                        key={ti}
                        className='flex-1 max-w-[220px] overflow-hidden text-ellipsis whitespace-nowrap text-center py-[4px]'
                        style={selectedTabIndex === ti ? { background: 'linear-gradient(to left, #108B96, #003A57)', color: 'white', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' } : { background: 'linear-gradient(to bottom, #ccc, #fff)', color: '#003A57', borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}
                        onClick={() => { setSelectedTabIndex(ti) }}
                    >
                        {tab.name}
                    </button>
                ))}
            </div>
            <div className='w-full flex flex-row bg-[white] items-center' style={{ borderBottom: '1px solid #E3E3E3', gap: 6, padding: 6 }}>
                <div className='cursor-pointer'>
                    <PreviousSvg height={30} width={30} />
                </div>
                <div className='cursor-pointer'>
                    <NextSvg height={30} width={30} />
                </div>
                <div className='cursor-pointer'>
                    <ReloadSvg height={30} width={30} />
                </div>
                <div className='flex-1'>
                    <input disabled={true} className='w-full text-[black] bg-[#EEF2F6] rounded-[4px]' value={content?.tabs?.[selectedTabIndex]?.url ?? 'https://task.com'} style={{ fontSize: fontSize - 4, height: 40, paddingLeft: 24, paddingRight: 24 }} />
                </div>
            </div>
            <div className='w-full flex flex-col overflow-auto flex-1 bg-white'>
                {content?.tabs?.[selectedTabIndex]?.contents?.map((content, ci) => (
                    <div key={ci}>
                        {content.type === '圖片' ?
                            <img className='w-full' src={content.url} alt='' />
                            : content.type === '標題' ?
                                <div className='text-black font-bold text-center w-[90%]' style={{ fontSize: fontSize + 4 }}>{content.text}</div>
                                : content.type === '文字' ?
                                    <div className='text-justify flex flex-col items-center justify-center font-[400]' dangerouslySetInnerHTML={{ __html: content.text }}></div>
                                    : content.type
                        }
                    </div>
                ))}

            </div>
        </div>
    )
}